import React from 'react';
import Buildings from './Buildings';

export default function Dispatch({ tab }) {
  return <Buildings tab={tab} />;
}